import { render } from "./BroadcastNotificationForm.vue?vue&type=template&id=04ae151e&scoped=true"
import script from "./BroadcastNotificationForm.vue?vue&type=script&lang=js"
export * from "./BroadcastNotificationForm.vue?vue&type=script&lang=js"

import "./BroadcastNotificationForm.vue?vue&type=style&index=0&id=04ae151e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ae151e"]])

export default __exports__